import { Loader2 } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-500 mx-auto mb-4" />
        <p className="text-zinc-500 text-sm font-mono">Initializing...</p>
      </div>
    </div>
  );
}
